import { useEffect, useId, useState } from 'react'
import type { FdeCopy } from '@/frontend/features/Fde/types'

export default function MermaidDiagram({ content, copy }: { content: string; copy: FdeCopy }) {
  const id = useId().replace(/:/g, '')
  const [svg, setSvg] = useState('')
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let active = true
    async function render() {
      try {
        const mermaid = (await import('mermaid')).default
        mermaid.initialize({ startOnLoad: false, securityLevel: 'strict', theme: 'neutral' })
        const result = await mermaid.render(`fde-mermaid-${id}`, content)
        if (active) { setSvg(result.svg); setFailed(false) }
      } catch {
        if (active) { setSvg(''); setFailed(true) }
      }
    }
    render()
    return () => { active = false }
  }, [content, id])

  if (failed) return <p className="rounded-lg border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">{copy.material.mermaid_error}</p>
  if (!svg) return <div className="flex min-h-52 items-center justify-center text-sm text-muted-foreground">{copy.common.loading}</div>
  return <div className="min-w-max [&_svg]:h-auto [&_svg]:max-w-none" dangerouslySetInnerHTML={{ __html: svg }} />
}
